



























































































































































import { Component, Vue } from 'vue-property-decorator'
import { membershipState } from '../../../store/modules/MembershipState'
import axios from 'axios'
import { Result } from '../../../modules/class/RegisterResponseInfo'
import ErrorFormResponse from '../../../modules/class/ErrorFormResponse'
import JsonUtil from '../../../modules/util/JsonUtil'
import PathUtil from '../../../modules/util/PathUtil'
import { SapLoginInfo, ssoLogin } from '../../../modules/util/SapUtil'
import UidCookie from '../../../modules/util/UidSetCookie'

// bookmarkのinterface
export interface BookmarkList {
  url: string
  title: string
  date: string
}

@Component
export default class MypageBookmarkList extends Vue {
  private readonly vueid = 'vue_mypage_bookmark_list'

  // --------------------------------------------------------------------------------------------------------------------
  // Props
  get showpage(): boolean {
    return membershipState.isLogin && this.bookmark.length > 0
  }

  // --------------------------------------------------------------------------------------------------------------------
  // data
  private result: Result = 'error'
  private resultError: ErrorFormResponse = {}
  private haserror = false
  private uidcookie = new UidCookie()

  private bookmark: BookmarkList[] = []

  // pagination
  private currentPage = 0 // 現在のページ番号
  private pageRange = 5 // ページネーションに表示するページ数の上限
  private size = 10 // 1ページに表示するアイテムの上限
  private showPrev = false
  private showNext = false

  // Showing
  private navhead = 1
  private navend = 10

  private urlData = ''

  // -------------------------------------------------------------------------------------------------------------------
  // hocks
  private created() {
    this.clearerror()
  }

  private mounted() {
    if (document.getElementById(this.vueid) !== null) {
      this.initbookmark()
    }
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * init get bookmark lsit
   */
  private async initbookmark() {
    this.verifyLoginBookmark()
  }

  /**
   * ブックマーク削除verifyLogin
   */
  private verifyLoginBookmark() {
    window.gigya.accounts.verifyLogin({
      include: 'preferences',
      callback: this.verifyLoginBookmarkResponse
    })
  }

  /**
   * ブックマーク削除コールバック
   */
  private async verifyLoginBookmarkResponse(response: {
    errorCode: number
    UID: string
    UIDSignature: string
    signatureTimestamp: string
  }) {
    if (response.errorCode === 0) {
      const info: SapLoginInfo = {
        UID: response.UID,
        UIDSignature: response.UIDSignature,
        signatureTimestamp: response.signatureTimestamp
      }

      // Cookieに３点セットをセット
      this.uidcookie.setUid(info)
      try {
        const res = await axios.post(PathUtil.makePath('/member/api/bookmark'))
        this.bookmark = res.data.bookmark
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 403) {
          ssoLogin(window.location.href, 'gigya-login-screen')
        }
      }
    } else {
      // ログインしていないときはCookieを消す
      this.uidcookie.unSetUid()
    }
  }

  /**
   * clear controll
   */
  private clearerror() {
    this.haserror = false
    this.resultError = {}
  }

  /**
   * delete bookmark
   */
  private async deletebookmark(url: string) {
    this.urlData = url
    window.gigya.accounts.verifyLogin({
      include: 'preferences',
      callback: this.verifyLoginBookmarkDelResponse
    })
  }

  /**
   * ブックマーク削除コールバック
   */
  private async verifyLoginBookmarkDelResponse(response: {
    errorCode: number
    UID: string
    UIDSignature: string
    signatureTimestamp: string
  }) {
    if (response.errorCode === 0) {
      const url = this.urlData
      const info: SapLoginInfo = {
        UID: response.UID,
        UIDSignature: response.UIDSignature,
        signatureTimestamp: response.signatureTimestamp
      }

      // Cookieに３点セットをセット
      this.uidcookie.setUid(info)
      const form = JSON.stringify({
        url: url
      })
      try {
        const res = await axios.post(
          PathUtil.makePath('/member/api/bookmark_delete'),
          form
        )

        this.result = res.data.result
        if (this.result === 'success') {
          // success delete
          // 一覧を再取得、再描画する
          this.initbookmark()
        } else {
          // error delete
          // エラーメッセージ表示
          this.haserror = true
          this.resultError = JsonUtil.jsonToObject<ErrorFormResponse>(
            ErrorFormResponse,
            res.data.errordata || {}
          )
        }
      } catch (err) {
        // TODO: システムエラー
      }
    } else {
      // ログインしていないときはCookieを消す
      this.uidcookie.unSetUid()
    }
  }

  /**
   * 以下、ページネーション用、computed, method
   */

  // ページ数を取得する
  get pages(): number {
    return Math.ceil(this.bookmark.length / this.size)
  }

  // ページネーションで表示するページ番号の範囲を取得する
  get displayPageRange(): number[] {
    const half = Math.ceil(this.pageRange / 2)
    let start, end

    this.showPrev = false
    this.showNext = false

    if (this.pages < this.pageRange) {
      // ページネーションのrangeよりページ数がすくない場合
      start = 1
      end = this.pages
    } else if (this.currentPage < half) {
      // 左端のページ番号が1になったとき
      start = 1
      end = start + this.pageRange - 1
    } else if (this.pages - half <= this.currentPage) {
      // 右端のページ番号が総ページ数になったとき
      end = this.pages
      start = end - this.pageRange + 1
    } else {
      // activeページを中央にする
      start = this.currentPage - half + 1
      end = this.currentPage + half
    }
    this.showPrev = !(this.currentPage + 1 === 1)
    this.showNext = this.currentPage + 1 !== this.pages

    const indexes: number[] = []
    for (let i = start; i <= end; i++) {
      indexes.push(i)
    }
    return indexes
  }

  // 表示件数変更
  private changerows() {
    // 途中ページで表示件数を変えると先頭に戻る（現在ページを維持できないため）
    this.currentPage = 0
  }

  // ページネーションに合わせてデータ取得変更
  get displayItems(): BookmarkList[] {
    const head = this.currentPage * this.size
    // Showing設定
    this.setshowing(head)
    return this.bookmark.slice(head, head + this.size)
  }

  // showingの値を設定する
  private setshowing(head: number) {
    const maxcount = this.bookmark.length
    // head
    if (maxcount > 0) {
      // 配列は0開始のためShowingは+1する
      this.navhead = head + 1
    } else {
      this.navhead = 0
    }
    // end
    if (head + this.size > maxcount) {
      // 最終ページのend
      this.navend = this.bookmark.length
    } else {
      this.navend = head + this.size
    }
    // 開始 <= 終了の関係を維持
    if (this.navhead > this.navend) {
      this.navhead = this.navend
    }
  }

  private selectHandler() {
    // 何か必要な処理があれば
  }

  // 未使用
  private first() {
    this.currentPage = 0
    this.selectHandler()
  }

  // 未使用
  private last() {
    this.currentPage = this.pages - 1
    this.selectHandler()
  }

  // prev
  private prev() {
    if (this.currentPage > 0) {
      this.currentPage--
      this.selectHandler()
    }
  }

  // next
  private next() {
    if (this.currentPage < this.pages - 1) {
      this.currentPage++
      this.selectHandler()
    }
  }

  // ページNo.選択
  private pageSelect(index: number) {
    this.currentPage = index - 1
    this.selectHandler()
  }
}
